import React, { useState } from 'react';
import logo from '../assets/logos/logo.png';
import '../styles/Header.css';

const Header = ({ onNavigate }) => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const handleNavClick = (page) => {
    onNavigate(page);
    setOpenDropdown(null);
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* LOGO - CLICK TO HOME */}
        <div className="logo-section">
          <img 
            src={logo} 
            alt="MaxInfra Logo"
            className="logo"
            onClick={() => handleNavClick('home')}
            style={{ cursor: 'pointer' }}
          />
        </div>

        {/* NAVIGATION MENU */}
        <nav className="navbar">
          <ul className="nav-menu">
            
          

            {/* ABOUT US */}
            <li>
              <a 
                onClick={() => handleNavClick('about-us')}
                style={{ cursor: 'pointer' }}
              >
                About Us
              </a>
            </li>

            {/* BUSINESS VERTICALS DROPDOWN */}
            <li className="dropdown">
              <a 
                onClick={() => toggleDropdown('verticals')}
                style={{ cursor: 'pointer' }}
              >
                Business Verticals ▼
              </a>
              {openDropdown === 'verticals' && (
                <ul className="dropdown-menu">
                  <li>
                    <a 
                      onClick={() => handleNavClick('railway-tunnels')}
                      style={{ cursor: 'pointer' }}
                    >
                      Railway Tunnels
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavClick('irrigation-tunnels')}
                      style={{ cursor: 'pointer' }}
                    >
                      Irrigation Tunnels
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavClick('road-tunnels')}
                      style={{ cursor: 'pointer' }}
                    >
                      Road Tunnels
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavClick('water-supply')}
                      style={{ cursor: 'pointer' }}
                    >
                      Water Supply Works
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavClick('bridges')}
                      style={{ cursor: 'pointer' }}
                    >
                      Bridges
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavClick('highways')}
                      style={{ cursor: 'pointer' }}
                    >
                      Highways
                    </a>
                  </li>
                </ul>
              )}
            </li>

            {/* PROJECTS DROPDOWN */}
            <li className="dropdown">
              <a 
                onClick={() => toggleDropdown('projects')}
                style={{ cursor: 'pointer' }}
              >
                Projects ▼
              </a>
              {openDropdown === 'projects' && (
                <ul className="dropdown-menu">
                  <li>
                    <a 
                      onClick={() => handleNavClick('ongoing-projects')}
                      style={{ cursor: 'pointer' }}
                    >
                      Ongoing Projects
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavClick('completed-projects')}
                      style={{ cursor: 'pointer' }}
                    >
                      Completed Projects
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavClick('facilities')}
                      style={{ cursor: 'pointer' }}
                    >
                      Facilities
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavClick('achievements')}
                      style={{ cursor: 'pointer' }}
                    >
                      Achievements
                    </a>
                  </li>
                </ul>
              )}
            </li>

            {/* CONTACT US */}
            <li>
              <a 
                onClick={() => handleNavClick('contact-us')}
                style={{ cursor: 'pointer' }}
              >
                Contact Us
              </a>
            </li>

          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;